/*
PURPOSE: Editorial mission / vision section for the home page — the "OUR VISION"
beat, the ecosystem bloom, and the join CTA.
USE CASES:
- Fourth section of the home page, after How It Works.
DOMAIN BOUNDARIES:
- Thin composition of editorial primitives + the EcosystemBloom wrapper +
  verbatim useCopy().publicPages.home.vision / cta copy. No fabricated
  strings. The legacy navy ocean wave was intentionally dropped — it
  clashed with the warm palette; sections transition via the editorial
  hairline rule instead.
- The CTA scrolls to the hero creator via the passed callback, matching the
  legacy addToEcosystem button.
- No imports from design-sandbox/.
*/

import React from 'react';
import { useCopy } from '../../../hooks/useCopy';
import { EditorialSection, Eyebrow, DisplayHeading, CtaPill } from '../../../components/editorial';
import EcosystemBloom from '../../../components/EcosystemBloom/EcosystemBloom';

interface MissionProps {
  onAddToEcosystem: () => void;
}

const Mission: React.FC<MissionProps> = ({ onAddToEcosystem }) => {
  const copy = useCopy();
  const { sectionTitle, description } = copy.publicPages.home.vision;

  return (
    <EditorialSection background="cream" id="mission">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <Eyebrow>{sectionTitle}</Eyebrow>
          <DisplayHeading as="h2" scale="heading" className="mt-8">
            {description}
          </DisplayHeading>
        </div>
        <div>
          <EcosystemBloom />
        </div>
      </div>

      <div className="flex justify-center mt-16">
        <CtaPill onClick={onAddToEcosystem}>{copy.publicPages.home.cta.addToEcosystem}</CtaPill>
      </div>
    </EditorialSection>
  );
};

export default Mission;
